(function () {

  'use strict';

  eclipseApp.factory('prepaidRefillOneTimeService', function() {

    var InteracParameters = null;
    var refillValue = null ;
    var billingType = null ;


    function setInteracParameters(data) {
      InteracParameters = data;
    }

    function getInteracParameters() {
      return InteracParameters;
    }

    function setRefillValue(data) {
      refillValue = data;
    }

    function getRefillValue() {
      return refillValue;
    }

    function setBillingType(data) {
      billingType = data;
    }

    function getBillingType() {
      return billingType;
    }


    return {
      setInteracParameters: setInteracParameters,
      getInteracParameters: getInteracParameters,
      setRefillValue: setRefillValue,
      getRefillValue: getRefillValue,
      setBillingType: setBillingType,
      getBillingType: getBillingType

    };

  });

})();
